import { isApplicationNonProd } from 'Utilities/helpers';
import { useFeatureFlags } from 'Utilities/hooks';

import { useVehicleCollectionSub } from 'Containers/app/vehicleCollection/hooks/useVehicleCollectionSub';

import { useIsDealerDirect } from './useIsDealerDirect';

const HANDSHAKE_DEALERS = Object.keys((isApplicationNonProd)
  ? {
    1193: 'Pajka',
    2118: 'Kshitij Dealer',
  }
  : {
    2227: 'First Class Motors (Internal)',
    // 11606: 'Kent Car Centre',
    // 13565: 'Auto100',
    22432: 'MOTORWAY TEST - PAYMENTS (Internal)',
    26679: 'Tracy Island Cars (Internal)',
    48960: 'NT Traders',
  }).map(Number);

export const useIsDealerDirectHandshake = () => {
  const { handshakeEnabled } = useFeatureFlags();
  const vehicleCollectionStatus = useVehicleCollectionSub();

  const { id: dealerId } = vehicleCollectionStatus?.offer?.closingBid?.dealer ?? {};
  const handshakeDealer = (handshakeEnabled)
    ? HANDSHAKE_DEALERS.some((dealer) => dealer === (dealerId ?? -1))
    : false;

  const isDealerDirect = useIsDealerDirect();

  return { handshakeDealer, isDealerDirect };
};
